module.exports = __webpack_public_path__ + "static/media/ru.7ad90aa0.svg";